export enum CustomPDFReportCreateOption {
    BLANK_REPORT = 'blank_report',
    NEW_FROM_TEMPLATE = 'new_from_template',
}

export enum CustomPDFReportTabDropdownOption {
    NEW_FROM_TEMPLATE = 'newFromTemplateReport',
    OPEN = 'openReport',
    REPORT_SETTINGS = 'openReportSettings',
    CLOSE = 'closeReport',
    DELETE = 'deleteReport',
    CONDENSE = 'condenseReport',
    RENAME = 'renameReport',
    SAVE_AS = 'saveAsReport',
    SAVE = 'saveReport',
}

export enum CustomPDFReportModuleDropdownOption {
    ADD_TO_SECTION = 'addToSection',
    DUPLICATE = 'duplicateModule',
    CREATE_SECTION = 'createSection',
    REMOVE_FROM_SECTION = 'removeFromSection',
    SAVED_ASSET_OPTIONS = 'SavedAssetOptions',
}
